import { APIClient } from '@autopylot-internal/autopylot-api-client';
import { ISO8601 } from '../notes/NotesClient.ts';

export type FrameType = 'fixed-wing' | 'rotary-wing' | 'other';
export type IDefaultType = 'primary' | 'backup';
export type AircraftStatus = 'active' | 'grounded' | 'archived';
export type IAircraftWeight = 'under-250g' | '250g-55lb' | 'over-55lb';

export interface AircraftResponse {
    userId: string;
    aircraftId: string;
    nickname: string;
    frameType: FrameType;
    defaultType?: IDefaultType;
    status: AircraftStatus;
    make: string;
    model: string;
    serial: string;
    value: number;
    weight: IAircraftWeight;
    faaRegistrationNumber: string;
    faaRegistrationDate: ISO8601;
    links: {
        self: { href: string; }
        mission: { href: string; }
        notes: { href: string; }
    }
    createdAt: string;
    createdBy: string;
    updatedBy: string;
    updatedAt: string;
    missions: string[]; // missionIds
}

export class FleetManagmentClient {
    static inject = () => [APIClient];
    constructor(private client: APIClient) { }

    addAircraft = async (aircraft: Partial<AircraftResponse>): Promise<AircraftResponse> => {
        const entry = await this.client.entry();
        return await this.client.post(entry.links.fleet, aircraft);
    };

    getFleet = async () => {
        const entry = await this.client.entry();
        return await this.client.get(entry.links.fleet);
    };

    updateAircraft = async (aircraft: AircraftResponse) => {
        return await this.client.put(aircraft.links.self, aircraft);
    };

    deleteAircraft = async (aircraft: AircraftResponse) => {
        await this.client.delete(aircraft.links.self, {});
    };

    assignAircraftToMission = async ({ aircraft, missionId }: { aircraft: AircraftResponse; missionId: string; }) => {
        await this.client.put(aircraft.links.mission, { missionId });
    };

    removeAircraftFromMission = async ({ aircraft, missionId }: { aircraft: AircraftResponse; missionId: string; }) => {
        await this.client.delete(aircraft.links.mission, { missionId });
    };
}
